import { Link, Typography } from "@mui/material";
import { getApiUrl } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const TERMS_AGREEMENT_RESOURCES =
  Resources.Pages.Content.CustomerAnonymousPaymentPay.TermsAgreement;

export const TermsAgreementText = () => {
  const { t } = useResource();

  return (
    <Typography textAlign="center" fontStyle="italic">
      {t(TERMS_AGREEMENT_RESOURCES.text)}
      <br />
      <Link
        href={t(TERMS_AGREEMENT_RESOURCES.link, { apiUrl: getApiUrl() })}
        fontWeight="bold"
        display="inline"
        sx={{ textDecoration: "none" }}
        ml={1}
      >
        {t(TERMS_AGREEMENT_RESOURCES.linkText)}
      </Link>
      .
    </Typography>
  );
};
